import gql from 'graphql-tag';

export const GET_ENROLLED_VNM_DATA = gql`
  query GetVnmEnrolledSolarProjectData($planId: Int!) {
    plan(id: $planId) {
      id
      billable
      vnmProductSubscription {
        id
        vnmSubscription {
          id
          mostRecentSubscriptionSubmission {
            calculatedAllocationKw
          }
          vnmSolarProject(nonCumulativeCalculatedFields: true) {
            id
            name
            city
            startDate
            acquisitionStatistics {
              estimatedHomesPowered
            }
            firstYearProductionEstimate
            image {
              thumbnail
            }
            utility {
              state {
                abbreviation
              }
            }
            mdIdentifier
          }
        }
      }
    }
  }
`;

export const getEnrolledVNMDataMock = {
  plan: {
    __typename: 'Plan',
    billable: true,
    id: 1,
    vnmProductSubscription: {
      id: 99,
      vnmSubscription: {
        id: 999,
        usage: {
          kwh: 807,
        },
        mostRecentSubscriptionSubmission: {
          calculatedAllocationKw: 2,
        },
        vnmSolarProject: {
          acquisitionStatistics: {
            estimatedHomesPowered: 300,
          },
          city: 'Sunnyside Uptown',
          firstYearProductionEstimate: 123456,
          id: 9999,
          image: {
            thumbnail: 'aws.sunnyside-up.com',
          },
          mdIdentifier: 'WEPUTOLDBAYONEVERYTHING',
          name: 'Sunnyside up',
          startDate: '2020-01-01',
          utility: {
            state: {
              abbreviation: 'FF',
            },
          },
        },
      },
    },
  },
};

export const GET_VNM_PLAN = gql`
  query GetVnmPlanData($planId: Int!) {
    plan(id: $planId) {
      id
      mostRecentStatement {
        id
        lineItems {
          id
          key
          vnmSavingsCents
        }
        singleUtilityStatement {
          id
          serviceStartDate
          serviceEndDate
          vnmProductionKwh
        }
      }
      cumulativeVnmSavings
    }
  }
`;

export const getVNMPlanMock = ({ hasSavings }) => {
  return {
    plan: {
      __typename: 'Plan',
      id: 1,
      mostRecentStatement: {
        id: 1,
        lineItems: [
          {
            id: 1,
            key: 'vnm_solar_charge',
            vnmSavingsCents: hasSavings ? 567 : 0,
          },
        ],
        singleUtilityStatement: {
          id: 1,
          serviceEndDate: '2020-02-02',
          serviceStartDate: '2020-01-02',
          vnmProductionKwh: 100,
        },
      },
      cumulativeVnmSavings: 1234,
    },
  };
};
